<template>
  <div class="background-video">
    <video muted loop autoplay>
      <source :src="src" type="video/mp4" />
    </video>
    <div class="gradient" />
  </div>
</template>

<script>
export default {
  name: "BackgroundVideo",
  props: {
    src: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.background-video {
  position: absolute;
  width: 100%;
  height: 100%;
}

video {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.gradient {
  position: absolute;
  width: 100%;
  height: 100%;
  background: $background-video-gradient-background;
}
</style>
